import React from "react";

const LinkedInIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="27"
      viewBox="0 0 28 27"
      fill="none"
    >
      <g clipPath="url(#clip0_2_586)">
        <path
          d="M10.5037 8.30524C10.5037 9.07468 10.0151 9.70375 9.10524 9.70375C8.26562 9.70375 7.70674 9.07468 7.70674 8.37543C7.70674 7.60599 8.26562 6.90674 9.10524 6.90674C9.94487 6.90674 10.5037 7.53581 10.5037 8.30524Z"
          fill="#364F8E"
        />
        <path
          d="M10.5037 10.403H7.70674V19.4933H10.5037V10.403Z"
          fill="#364F8E"
        />
        <path
          d="M17.2181 10.5434C15.7494 10.5434 14.9098 11.383 14.5615 11.9419H14.4913L14.3509 10.7539H11.8347C11.8347 11.5234 11.9048 12.4332 11.9048 13.4807V19.4933H14.7018V14.5283C14.7018 14.2476 14.7018 14.0396 14.772 13.8291C14.9826 13.3404 15.3309 12.7113 16.1004 12.7113C17.0803 12.7113 17.4989 13.5509 17.4989 14.6687V19.4933H20.2959V14.3178C20.2959 11.7313 18.9675 10.5408 17.2181 10.5408V10.5434Z"
          fill="#364F8E"
        />
        <path
          d="M21.8165 26.4H6.18346C3.21489 26.4 0.800003 23.9851 0.800003 21.0165V5.38346C0.800003 2.41489 3.21489 0 6.18346 0H21.8165C24.7851 0 27.2 2.41489 27.2 5.38346V21.0165C27.2 23.9851 24.7851 26.4 21.8165 26.4ZM6.18346 1.47389C4.02592 1.47389 2.27389 3.22851 2.27389 5.38346V21.0165C2.27389 23.1741 4.02852 24.9261 6.18346 24.9261H21.8165C23.9741 24.9261 25.7261 23.1715 25.7261 21.0165V5.38346C25.7261 3.22592 23.9715 1.47389 21.8165 1.47389H6.18346Z"
          fill="#364F8E"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_586">
          <rect
            width="26.4"
            height="26.4"
            fill="white"
            transform="translate(0.800003)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LinkedInIcon;
